'use strict';
exports.__esModule = true;
exports.getElementTextStyles = exports.getTextWidth = void 0;
var feature_detection_1 = require('@eventbrite/feature-detection');
var getTextWidth = function (text, element) {
    if (text === void 0) {
        text = '';
    }
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    if (!ctx) {
        return;
    }
    ctx.font = (0, exports.getElementTextStyles)(element);
    return ctx.measureText(text).width;
};
exports.getTextWidth = getTextWidth;
var getElementTextStyles = function (element) {
    var _a;
    var computedStyle =
        (_a = (0, feature_detection_1.getWindowObject)('getComputedStyle')) ===
            null || _a === void 0
            ? void 0
            : _a(element);
    if (!computedStyle) {
        return '';
    }
    var fontSize = computedStyle.getPropertyValue('font-size');
    var fontFamily = computedStyle.getPropertyValue('font-family');
    return ''.concat(fontSize, ' ').concat(fontFamily); // '20px Arial'
};
exports.getElementTextStyles = getElementTextStyles;
